require('./collegeCommitmentsService');

"use strict";

angular.module('app.collegeCommitments.collegeCommitmentsController', [
  'app.collegeCommitments.collegeCommitmentsList',
])
  .controller('app.collegeCommitments.collegeCommitmentsController', [
    '$scope',
    'app.collegeCommitments.collegeCommitmentsList',
    '$anchorScroll',
    function ($scope, collegeCommitmentsList, $anchorScroll) {

      $scope.sortData = {
        sortTypeSelected: 'commitDateReverse',
        sortingInprog: true,
        initialSortRun: false,
      };
      $scope.collegeCommitmentsList = collegeCommitmentsList;
      $scope.players = null;
      $scope.isInitialized = false;

      $scope.pager = {
        items: [],
        pageSize: 50,
        currentPage: 1,
        pageChanged: function () {
          if (Array.isArray($scope.players)) {
            let start = (this.currentPage - 1) * this.pageSize;
            let end = start + this.pageSize;

            this.items = $scope.players.slice(start, end);
          }

          if ($scope.isInitialized) {
            $anchorScroll('scrollToTop');
          }
        },
        reset: function () {
          this.currentPage = 1;
          this.pageChanged();
        },
      };

      /**
       *
       * @param {CollegeCommPlayer[]} players
       * @returns {*}
       */
      let updateGridData = function (players) {

        let returnVal = null;

        if (players !== null && typeof players !== 'undefined') {
          if (players.length > 0) {

            let tempArray = [];

            for (let i = 0; i < players.length; i++) {

              // fix missing long name fields
              if (players[i].current_team === null || typeof players[i].current_team === 'undefined') {
                players[i].current_team = {
                  long_name: ""
                };
              }

              // generate year string
              let tempYearString = "";
              if (players[i].comm_year !== null && typeof players[i].comm_year !== 'undefined') {

                tempYearString = moment(players[i].comm_year).year();
              }

              // generate date string
              let tempDateString = "";
              if (players[i].comm_date !== null && typeof players[i].comm_date !== 'undefined') {
                tempDateString = moment(players[i].comm_date).format('MM/DD/YYYY');
              }

              //generate date string year-order first
              let tempDateStringYearOrder = "";
              if (players[i].comm_date !== null && typeof players[i].comm_date !== 'undefined') {
                tempDateStringYearOrder = moment(players[i].comm_date).format('YYYY/MM/DD');
              }

              let tempObject = {
                "name": players[i].first_name + ' ' + players[i].last_name,
                "nameLastFirst": players[i].last_name + ", " + players[i].first_name,
                "position": players[i].position,
                "commitTeam": players[i].comm_team.long_name,
                "commitDate": tempDateString,
                "commitDateYearOrder": tempDateStringYearOrder,
                "commitYear": tempYearString,
                "currentTeam": players[i].current_team.long_name
              };

              tempArray.push(tempObject);
            }

            returnVal = tempArray;
          }
        }

        return returnVal;
      };

      let sortPlayers = function () {

        $scope.sortData.sortingInprog = true;

        window.setTimeout(function () {

          let tempPlayers = $scope.players.slice(0);

          if ($scope.sortData.sortTypeSelected === "name") {
            tempPlayers.sort(function (a, b) {
              return compare(a["nameLastFirst"], b["nameLastFirst"]);
            });
          } else if ($scope.sortData.sortTypeSelected === "commitDate") {
            tempPlayers.sort(function (a, b) {
              return compare(a["commitDateYearOrder"], b["commitDateYearOrder"]);
            });
          } else if ($scope.sortData.sortTypeSelected === "nameReverse") {
            tempPlayers.sort(function (a, b) {
              return compare(a["nameLastFirst"], b["nameLastFirst"]);
            });
            tempPlayers.reverse();
          } else if ($scope.sortData.sortTypeSelected === "positionReverse") {
            tempPlayers.sort(function (a, b) {
              return compare(a["position"], b["position"]);
            });
            tempPlayers.reverse();
          } else if ($scope.sortData.sortTypeSelected === "commitTeamReverse") {
            tempPlayers.sort(function (a, b) {
              return compare(a["commitTeam"], b["commitTeam"]);
            });
            tempPlayers.reverse();
          } else if ($scope.sortData.sortTypeSelected === "commitYearReverse") {
            tempPlayers.sort(function (a, b) {
              return compare(a["commitYear"], b["commitYear"]);
            });
            tempPlayers.reverse();
          } else if ($scope.sortData.sortTypeSelected === "commitDateReverse") {
            tempPlayers.sort(function (a, b) {
              return compare(a["commitDateYearOrder"], b["commitDateYearOrder"]);
            });
            tempPlayers.reverse();
          } else if ($scope.sortData.sortTypeSelected === "currentTeamReverse") {
            tempPlayers.sort(function (a, b) {
              return compare(a["currentTeam"], b["currentTeam"]);
            });
            tempPlayers.reverse();
          } else {
            tempPlayers.sort(function (a, b) {
              return compare(a[$scope.sortData.sortTypeSelected], b[$scope.sortData.sortTypeSelected]);
            });
          }

          $scope.players = tempPlayers;

          $scope.pager.reset();

          $scope.sortData.sortingInprog = false;
          $scope.$digest();

          $scope.sortData.initialSortRun = true;
        }, 100);
      };

      let init = function () {
        if (!collegeCommitmentsList.players) {
          collegeCommitmentsList.retrieve();
        }

        $scope.isInitialized = true;
      };

      $scope.$watch(function () {
        return $scope.sortData.sortTypeSelected;
      }, function () {

        if ($scope.players && $scope.sortData.initialSortRun) {
          sortPlayers();
        }
      });

      $scope.$watch(function () {
        return collegeCommitmentsList.players;
      }, function () {

        $scope.players = updateGridData(collegeCommitmentsList.players);

        if ($scope.players) {
          sortPlayers();
        }

      });

      init();
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/collegeCommitments/collegeCommitmentsController.js